var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKozmikBumzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 172,
    viewBox: "0 0 388 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.913 72.8422C115.16 73.336 114.421 73.9287 114.073 74.7592C113.597 75.8976 113.997 77.2766 114.848 78.1686C115.7 79.0607 116.924 79.5197 118.147 79.6813C115.207 79.6315 112.278 81.0631 110.509 83.4115C109.439 84.8323 108.781 86.599 108.866 88.3751C108.951 90.1512 109.833 91.914 111.317 92.894C112.656 93.7782 114.345 93.968 115.946 93.8749C118.262 93.7397 120.547 93.0566 122.556 91.8976C119.609 94.4262 119.481 99.5634 122.31 102.224C124.976 104.728 129.285 104.709 132.596 103.154C135.906 101.596 138.439 98.8 140.857 96.0581C142.922 101.13 148.937 104.343 154.234 102.946C159.531 101.548 163.209 95.5054 161.739 90.2288C162.715 92.5534 165.782 93.4378 168.176 92.6487C170.569 91.8596 172.345 89.823 173.652 87.6678C175.086 85.3008 176.109 82.6836 176.654 79.9693C177.54 75.5808 176.849 70.3615 173.213 67.7487C171.387 66.4382 169.061 65.9797 166.815 66.042C161.302 66.1987 155.987 69.5203 153.433 74.4097C155.591 70.1885 156.425 65.0483 154.58 60.679C152.737 56.3095 147.761 53.1554 143.171 54.3429C141.521 54.7706 140.039 55.6919 138.71 56.7556C133.862 60.6397 130.803 66.6692 130.529 72.8734C130.317 71.7733 129.96 70.7011 129.469 69.6931C129.299 69.3437 129.059 68.9637 128.675 68.904C128.27 68.8421 127.92 69.1686 127.661 69.4847C126.822 70.5151 126.237 71.7394 125.952 73.0352C122.357 71.5136 119.612 70.4203 115.909 72.8453L115.913 72.8422Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.347 71.745C115.964 72.9184 116.271 74.2624 117.122 75.1545C117.974 76.0465 119.198 76.5056 120.421 76.6672C117.481 76.6174 114.552 78.0489 112.783 80.3974C111.713 81.8182 111.055 83.5848 111.14 85.3609C111.225 87.137 112.107 88.8998 113.591 89.8798C114.93 90.7641 116.619 90.9538 118.22 90.8608C120.536 90.7255 122.821 90.0424 124.83 88.8835C121.883 91.412 121.755 96.5493 124.584 99.2096C127.25 101.714 131.559 101.695 134.87 100.14C138.18 98.5818 140.713 95.7859 143.131 93.044C145.196 98.1163 151.211 101.329 156.508 99.9316C161.805 98.5342 165.483 92.4912 164.013 87.2146C164.989 89.5392 168.056 90.4237 170.45 89.6345C172.843 88.8454 174.618 86.8088 175.926 84.6537C177.359 82.2866 178.383 79.6694 178.928 76.9552C179.814 72.5667 179.123 67.3473 175.487 64.7345C173.661 63.424 171.335 62.9655 169.089 63.0278C163.576 63.1845 158.261 66.5062 155.707 71.3955C157.865 67.1744 158.699 62.0341 156.854 57.6649C155.011 53.2953 150.035 50.1412 145.445 51.3287C143.795 51.7564 142.313 52.6777 140.984 53.7414C136.136 57.6255 133.077 63.655 132.803 69.8593C132.591 68.7592 131.889 67.0947 130.178 67.0872C128.331 67.0785 128.188 69.6808 128.459 70.9114C125.282 68.8622 117.736 67.4879 116.348 71.75L116.347 71.745Z",
    fill: "#B3FEFF",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2112 72.3012C44.1009 71.1164 41.1936 70.9032 39.4428 72.5732C37.6186 74.314 37.7733 77.2555 38.3832 79.702C35.5808 77.8425 32.1186 76.8722 28.7967 77.408C25.4773 77.9434 22.3723 80.1006 21.0527 83.1931C19.7334 86.2881 20.4501 90.2353 23.0167 92.4104C22.0494 91.2471 20.3724 90.8514 18.8857 91.1302C17.3991 91.409 16.0821 92.2693 14.9455 93.2657C12.8431 95.1086 11.1677 97.6053 10.9195 100.389C10.6192 103.737 12.5295 107.096 15.3994 108.843C18.2696 110.592 21.9423 110.796 25.122 109.713C27.6876 108.837 29.9826 107.181 32.6454 106.675C31.4414 108.558 31.8347 111.169 33.1794 112.955C34.524 114.741 36.642 115.802 38.8031 116.377C41.1445 116.997 43.6692 117.107 45.9646 116.337C49.0212 115.311 51.3556 112.874 53.5604 110.52C56.3905 115.008 63.0153 116.106 67.6933 113.602C72.3716 111.101 75.0883 105.793 75.5409 100.507C78.7556 100.664 81.8755 98.7217 83.5396 95.9643C85.2013 93.2073 85.5114 89.7669 84.814 86.624C83.9088 82.5367 81.2014 78.7447 77.3408 77.1266C73.4802 75.5085 68.5308 76.4336 65.9398 79.7218C67.6772 77.0373 67.9407 73.4623 66.6154 70.5535C66.1025 69.43 65.3256 68.3661 64.2159 67.8255C62.8819 67.1776 61.2743 67.3851 59.8921 67.9241C55.2821 69.7247 52.6981 74.7015 51.6195 79.5331C51.5294 79.9341 50.6255 78.0356 50.6216 78.0261C50.2864 77.2711 50.1311 76.4858 49.7001 75.7493C48.8645 74.3204 47.6511 73.1109 46.2084 72.2991L46.2112 72.3012Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.719 69.5586C40.0576 71.4531 40.0495 74.2409 40.6595 76.6874C37.857 74.8278 34.3948 73.8576 31.0729 74.3934C27.7535 74.9288 24.6485 77.086 23.3289 80.1785C22.0096 83.2735 22.7263 87.2207 25.293 89.3957C24.3256 88.2325 20.5753 88.1221 17.2218 90.2511C14.8618 91.7492 13.4439 94.5907 13.1957 97.3742C12.8954 100.722 14.8058 104.081 17.6756 105.828C20.5458 107.577 29.4818 107.297 34.9213 103.658C33.7173 105.541 34.1106 108.152 35.4552 109.938C36.7999 111.724 38.9179 112.785 41.0789 113.36C43.4203 113.98 45.9451 114.09 48.2405 113.32C51.2971 112.294 53.6314 109.857 55.8363 107.503C58.6664 111.991 65.2911 113.088 69.9691 110.585C74.6475 108.084 77.3641 102.776 77.8167 97.4895C81.0315 97.6471 84.1514 95.7047 85.8155 92.9472C87.4796 90.1898 87.7872 86.7498 87.0899 83.6069C86.1847 79.5196 83.4773 75.7276 79.6167 74.1095C75.7561 72.4914 70.8066 73.4165 68.2157 76.7047C69.9531 74.0203 70.2166 70.4452 68.8913 67.5365C68.3784 66.4129 67.6014 65.3491 66.4918 64.8084C65.1578 64.1605 63.5501 64.368 62.168 64.907C57.558 66.7076 54.974 71.6844 53.8954 76.516C53.8053 76.917 53.2373 73.9955 52.8767 73.2214C51.276 69.7687 45.3472 65.4114 41.7158 69.554L41.719 69.5586Z",
    fill: "#B3FEFF",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.749 33.9001L32.8631 151.717C32.0216 153.83 33.7772 156.066 36.0279 155.75L160.358 138.34C162.612 138.024 163.684 135.395 162.294 133.593L84.8515 33.1856C83.4494 31.3669 80.5976 31.7663 79.749 33.9001Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.996 29.3926L36.1127 147.21C35.2711 149.322 37.0267 151.558 39.2775 151.243L163.608 133.832C165.861 133.517 166.933 130.888 165.543 129.085L88.0985 28.6781C86.6964 26.8595 83.8447 27.2588 82.996 29.3926Z",
    fill: "#05FFAE",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.997 113.743C113.163 113.103 142.001 109.163 145.167 108.523",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3745 122.092C53.5406 121.452 82.3786 117.512 85.5446 116.872",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4428 60.9515C77.431 59.5114 85.4066 58.856 92.2075 57.5733",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3802 73.9217C71.3968 72.8371 76.4753 72.2394 79.5324 71.6852",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2313 58.8163C83.8749 56.2712 83.4083 52.9396 83.1173 50.5014",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3255 60.7698C71.7548 64.4118 72.1925 68.2216 72.6214 71.8611C72.6019 71.6494 72.582 71.4354 72.5625 71.2237",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.132 56.3615C99.325 59.1262 99.5907 61.8882 99.9279 64.6378",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1343 88.7522C62.5481 88.6375 67.2601 87.8894 68.6392 87.5626",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.559 126.661C121.726 126.021 155.875 121.292 159.041 120.652",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.201 125.188C128.635 128.32 128.95 131.435 129.422 134.574",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.787 109.703C138.468 112.803 138.858 117.587 139.33 120.724",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4654 123.676C63.8182 126.862 64.1678 130.71 64.6402 133.849",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3073 135.955C49.9886 139.055 50.4795 144.56 50.9515 147.696",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M102.786 137.795C103.107 139.097 103.29 140.435 103.326 141.777C103.315 141.625 103.307 141.475 103.295 141.322",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7611 136.196C48.406 136.291 74.4946 132.365 76.1145 132.065",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0918 133.535C79.5322 136.212 79.973 138.891 80.4135 141.569",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6997 104.862C59.1307 104.645 62.4601 104.056 66.2923 103.562",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8486 106.997C56.0471 109.422 56.3279 111.842 56.6928 114.25",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8033 46.4199C83.9398 45.2643 90.5766 44.4307 97.4404 43.2199",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5663 36.0217C92.8344 38.0445 93.194 40.0545 93.6396 42.0474",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6321 111.509C62.904 112.928 63.1586 114.35 63.4503 115.767C65.9274 127.712 74.5296 136.375 86.3547 138.447C95.2065 139.996 103.854 138.843 111.939 134.917C121.155 130.441 126.549 123 127.736 112.732C128.465 106.413 127.701 100.221 125.577 94.2311C122.204 84.7193 115.745 78.4265 105.851 76.0066C96.0952 73.6227 86.6351 74.897 77.7169 79.3208C68.8837 83.7026 63.7428 91.0045 62.53 100.803C62.0946 104.321 61.9156 107.869 62.6345 111.509L62.6321 111.509Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5883 106.012C64.8602 107.432 65.1148 108.854 65.4065 110.27C67.8836 122.215 76.4858 130.878 88.3109 132.95C97.1627 134.499 105.81 133.347 113.895 129.42C123.111 124.944 128.505 117.504 129.692 107.235C130.421 100.916 129.658 94.7238 127.533 88.7343C124.161 79.2225 117.701 72.9297 107.807 70.5098C98.0513 68.1259 88.5913 69.4002 79.6731 73.824C70.8398 78.2058 65.6989 85.5077 64.4861 95.306C64.0508 98.8244 64.138 102.779 64.5907 106.012L64.5883 106.012Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2203 126.562C109.345 128.66 120.958 115.532 119.202 102.452C104.871 109.853 80.7648 113.801 80.7648 113.801C80.7648 113.801 83.1764 125.026 94.2199 126.559L94.2203 126.562Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M129.546 96.931C129.153 94.164 128.488 91.4302 127.533 88.7369C124.161 79.2251 117.704 72.9319 107.807 70.5123C98.0518 68.1284 88.5917 69.4027 79.6736 73.8266C70.8428 78.2079 65.6994 85.5102 64.4866 95.3085C64.0513 98.8269 64.1385 102.782 64.5912 106.014C64.8631 107.434 65.1177 108.856 65.4094 110.273C65.7747 112.035 66.2899 113.715 66.911 115.323C96.9232 113.249 118.209 103.91 129.546 96.931Z",
    fill: "#FCE3B9",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M88.3537 107.393C88.3537 107.393 79.1701 108.679 75.0784 106.49C71.45 104.55 68.8792 86.785 76.0155 75.958C69.4153 80.4204 65.5159 86.9533 64.4816 95.3068C64.0462 98.8252 64.1335 102.78 64.5861 106.013C64.8581 107.432 65.1127 108.854 65.4044 110.271C65.7697 112.033 66.2849 113.713 66.9063 115.324C74.7616 114.781 82.0096 113.738 88.6475 112.372C88.4571 112.381 88.2519 112.393 88.017 112.408C77.235 113.121 88.3516 107.395 88.3516 107.395L88.3537 107.393Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M107.337 109.743C108.113 114.942 110.477 118.573 113.698 115.84C116.919 113.106 115.805 106.411 115.805 106.411L107.337 109.743Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M146.136 134.259C148.703 135.607 149.58 138.81 149.977 141.682C150.375 144.555 150.667 147.709 152.708 149.766C153.337 150.399 154.243 150.913 155.096 150.647C156.048 150.35 156.471 149.247 156.626 148.262C157.082 145.323 156.288 142.355 155.999 139.394C155.711 136.434 156.087 133.103 158.306 131.12",
    fill: "#05FFAE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M146.136 134.259C148.703 135.607 149.58 138.81 149.977 141.682C150.375 144.555 150.667 147.709 152.708 149.766C153.337 150.399 154.243 150.913 155.096 150.647C156.048 150.35 156.471 149.247 156.626 148.262C157.082 145.323 156.288 142.355 155.999 139.394C155.711 136.434 156.087 133.103 158.306 131.12",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4556 147.066C58.2256 148.244 59.539 151.644 60.1594 154.76C60.7823 157.875 61.0954 161.246 62.9704 163.74C63.6429 164.634 64.8483 165.408 65.7108 164.761C66.0234 164.525 66.2148 164.145 66.3529 163.763C66.991 162.017 66.7863 160.051 66.7385 158.161C66.7143 157.213 66.7407 156.231 67.1051 155.376C67.4695 154.52 68.2531 153.813 69.1381 153.848C71.4026 153.937 72.1163 157.665 74.3494 158.124C75.5333 158.367 76.7536 157.356 77.1498 156.259C77.8082 154.442 77.4586 151.999 77.1963 150.054C76.9478 148.207 76.3073 146.191 77.1679 144.593",
    fill: "#05FFAE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4556 147.066C58.2256 148.244 59.539 151.644 60.1594 154.76C60.7823 157.875 61.0954 161.246 62.9704 163.74C63.6429 164.634 64.8483 165.408 65.7108 164.761C66.0234 164.525 66.2148 164.145 66.3529 163.763C66.991 162.017 66.7863 160.051 66.7385 158.161C66.7143 157.213 66.7407 156.231 67.1051 155.376C67.4695 154.52 68.2531 153.813 69.1381 153.848C71.4026 153.937 72.1163 157.665 74.3494 158.124C75.5333 158.367 76.7536 157.356 77.1498 156.259C77.8082 154.442 77.4586 151.999 77.1962 150.054C76.9478 148.207 76.3073 146.191 77.1679 144.593",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M124.933 8.80013L129.16 18.3235L117.248 33.8793L124.424 31.0965L126.936 38.7517L112.604 57.007L118.516 56.2195L120.386 62.8246L96.9606 88.9L94.028 87.21L104.546 65.3252L104.841 57.8671L105.473 67.9972L94.7494 68.9138L91.4074 64.444L100.809 50.3996L104.108 44.15L92.8318 45.207L89.4586 39.5235L124.933 8.80013Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0704 10.8962L124.933 8.80006L109.453 30.7418L124.424 31.0965L108.042 55.5702L118.516 56.2194L94.028 87.2099L100.8 63.8599L91.4074 64.4439L102.603 39.7103L89.4585 39.5235L97.0704 10.8962Z",
    fill: "url(#paint0_linear_984_1916)",
    stroke: "black",
    strokeWidth: 0.520516,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8678 57.7189C68.8696 54.9353 71.2689 47.2708 69.7912 35.4939C71.6151 47.2223 76.032 53.9298 83.5309 54.6778C76.5291 57.4614 74.1298 65.1259 75.6075 76.9028C73.7835 65.1744 69.3666 58.4669 61.8678 57.7189Z",
    fill: "#F9FF8E",
    stroke: "#231F20",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M133.566 98.8118C138.788 96.7363 140.575 91.0212 139.474 82.2404C140.833 90.9852 144.128 95.9861 149.719 96.5423C144.496 98.6177 142.709 104.333 143.81 113.114C142.452 104.369 139.157 99.368 133.566 98.8118Z",
    fill: "#F9FF8E",
    stroke: "#231F20",
    strokeWidth: 0.520516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M366.643 105.117C371.592 103.914 373.916 99.0147 374.029 91.0039C374.15 99.0147 376.478 103.911 381.427 105.112C376.478 106.315 374.153 111.214 374.041 119.225C373.919 111.214 371.592 106.318 366.643 105.117Z",
    fill: "#F9FF8E",
    stroke: "#231F20",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M154.46 72.4053C159.409 71.3026 161.733 66.8165 161.846 59.4841C161.967 66.8165 164.294 71.3026 169.244 72.3996C164.294 73.5023 161.97 77.9884 161.858 85.3208C161.736 77.9884 159.409 73.5052 154.46 72.4053Z",
    fill: "#F9FF8E",
    stroke: "#231F20",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M237.919 129.892C237.884 129.785 237.849 129.681 237.812 129.574C236.031 124.516 232.206 122.81 227.723 122.597C225.974 122.513 225.39 122.325 223.638 122.403C223.28 122.418 224.002 121.843 223.638 121.771C223.915 121.549 223.678 121.029 223.991 120.893C225.413 120.273 225.127 120.917 226.506 120.204C228.055 119.401 229.278 118.347 230.119 117.034L230.151 117.094L233.799 109.932L232.279 107.759L230.937 108.356C230.125 105.002 228.298 102.349 224.861 100.92C221.716 99.6122 218.478 99.4621 215.31 99.9759C209.985 100.839 188.411 101.142 188.411 101.142L185.514 106.702C185.5 106.725 185.488 106.751 185.476 106.777C185.332 107.083 185.343 107.513 185.505 108.134C187.425 115.484 189.24 122.862 191.087 130.212C192.544 137.755 194.01 145.267 195.432 152.787C195.629 153.832 195.872 154.374 196.991 154.117C206.689 151.88 216.437 149.833 226.084 147.391C229.032 146.644 231.911 145.171 234.484 143.448C236.126 142.345 237.277 141.029 237.994 139.528L240.379 134.741L237.921 129.9L237.919 129.892ZM205.992 121.915C205.79 121.419 205.781 120.839 205.675 120.296C205.116 117.425 206.131 115.643 208.721 114.952C210.109 114.831 211.491 114.609 212.881 114.618C214.306 114.629 215.208 115.541 215.57 117.103C215.92 118.622 215.714 120.091 214.379 120.57C211.913 121.459 209.334 122.019 206.785 122.643C206.579 122.692 206.117 122.233 205.99 121.913L205.992 121.915ZM217.535 134.626C216.171 135.102 214.766 135.454 213.381 135.861C213.37 135.821 213.361 135.781 213.35 135.74C212.312 135.896 211.283 136.136 210.239 136.159C209.855 136.167 209.193 135.737 209.08 135.368C208.588 133.789 208.273 132.152 207.86 130.547C207.632 129.661 207.866 129.236 208.698 129.069C211.092 128.59 213.454 127.931 215.865 127.559C218.565 127.143 220.027 128.038 220.53 130.085C221.065 132.253 220.129 133.722 217.538 134.629L217.535 134.626Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M240.772 123.878C238.991 118.821 235.166 117.115 230.683 116.901C228.934 116.817 227.185 117.094 225.43 117.172C225.072 117.187 224.702 117.04 224.337 116.967C224.615 116.745 224.861 116.451 225.173 116.315C226.595 115.694 228.084 115.218 229.463 114.505C232.865 112.744 234.704 109.782 234.343 105.49C233.949 100.807 232.174 97.0343 227.818 95.2214C224.673 93.9137 221.435 93.7636 218.267 94.2774C212.942 95.1406 207.652 96.2346 202.376 97.3605C198.072 98.2785 193.811 99.4014 189.526 100.403C188.457 100.654 188.116 101.102 188.463 102.433C190.382 109.782 192.197 117.161 194.045 124.511C195.502 132.054 196.967 139.565 198.39 147.085C198.586 148.13 198.829 148.673 199.948 148.416C209.646 146.179 219.394 144.132 229.041 141.69C231.989 140.942 234.869 139.47 237.441 137.746C242.119 134.609 242.827 129.715 240.772 123.878ZM208.637 114.603C208.079 111.732 209.094 109.951 211.684 109.26C213.072 109.139 214.454 108.916 215.844 108.925C217.269 108.936 218.171 109.849 218.533 111.41C218.883 112.929 218.677 114.398 217.342 114.877C214.876 115.767 212.297 116.327 209.748 116.95C209.542 116.999 209.08 116.54 208.953 116.22C208.75 115.723 208.742 115.143 208.635 114.6L208.637 114.603ZM220.498 128.933C219.134 129.409 217.729 129.762 216.344 130.169C216.333 130.128 216.324 130.088 216.313 130.047C215.275 130.2 214.246 130.443 213.202 130.466C212.818 130.475 212.156 130.045 212.043 129.675C211.551 128.096 211.236 126.459 210.823 124.854C210.595 123.968 210.829 123.544 211.661 123.376C214.055 122.897 216.417 122.239 218.828 121.866C221.528 121.451 222.99 122.346 223.493 124.389C224.028 126.557 223.092 128.027 220.501 128.933H220.498Z",
    fill: "url(#paint1_linear_984_1916)",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M275.935 99.8576C276.118 98.7086 277.228 95.3571 278.872 94.2774C281.593 92.4934 284.504 93.7751 287.198 95.4033C294.916 100.074 299.472 108.313 299.533 115.582C300.288 102.118 312.221 91.5898 328.022 91.5552C329.675 91.5523 332.138 92.0228 333.549 93.0707C335.472 94.4968 335.654 97.6578 335.417 99.7219C333.838 113.599 327.938 124.987 321.477 136.947C319.592 140.437 317.271 144.222 312.683 144.911C311.42 145.102 308.307 144.649 307.737 141.508C306.777 136.211 307.812 130.267 309.405 125.53C311.521 122.178 312.802 118.763 314.542 114.745C311.498 121.918 309.44 126.95 303.884 132.553C302.103 134.349 299.186 133.61 297.576 131.182C296.287 129.239 292.818 120.521 290.924 112.701C294.341 126.274 298.4 140.394 293.59 152.128C293.063 153.41 291.583 154.963 289.95 155.122C287.412 155.373 285.154 152.688 283.992 150.443C275.351 133.74 273.423 115.628 275.935 99.8604V99.8576Z",
    fill: "#772DF0",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M286.016 97.2769C285.992 97.4011 286.024 97.5339 286.065 97.6638C286.585 99.3987 288.383 100.643 289.823 101.974C291.54 103.561 292.873 105.461 294.09 107.378C294.7 108.336 295.286 109.309 295.992 110.218C296.139 110.406 296.324 110.611 296.553 110.643C296.717 110.666 296.859 110.588 296.966 110.49C297.278 110.201 297.339 109.722 297.244 109.269C297.145 108.815 296.908 108.379 296.674 107.952C295.576 105.952 294.442 103.954 293.04 102.092C292 100.706 290.803 99.393 289.424 98.2787C288.912 97.8658 286.247 95.9606 286.016 97.2769Z",
    fill: "#E4BAFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M282.978 95.0888C282.671 94.9531 282.327 95.0772 282.185 95.3168C282.044 95.5564 282.073 95.8826 282.191 96.1771C282.388 96.6563 282.885 97.1037 283.402 97.1239C283.905 97.1412 284.281 96.7082 284.206 96.2319C284.131 95.7556 283.642 95.311 283.134 95.2244",
    fill: "#E4BAFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M324.449 93.2731C324.726 93.2645 325.151 93.2876 325.435 93.3482C325.718 93.4088 326.013 93.6109 326.088 93.8736C326.198 94.2604 325.669 94.5029 325.319 94.653C323.353 95.4931 319.005 95.6057 317.184 96.6536C316.479 97.0606 315.016 98.377 314.062 97.7101C313.735 97.4821 313.871 96.9163 314.172 96.541C315.031 95.4729 317.086 94.9388 318.401 94.451C319.717 93.9631 322.61 93.3367 324.449 93.2703V93.2731Z",
    fill: "#E4BAFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M328.699 93.7984C328.545 94.4681 329.155 95.3139 329.921 95.5102C331.176 95.8335 331.925 94.5836 331.078 93.6252C330.346 92.7966 328.936 92.7736 328.699 93.7984Z",
    fill: "#E4BAFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M329.479 116.971C329.771 116.445 329.982 115.871 330.109 115.27C330.161 115.025 330.173 114.71 329.938 114.531C329.806 114.427 329.629 114.407 329.473 114.419C328.84 114.471 328.461 114.999 328.181 115.501C326.669 118.223 326.056 121.41 324.9 124.323C324.44 125.478 323.897 126.592 323.269 127.655C322.818 128.422 322.313 129.185 322.182 130.094C322.156 130.267 322.165 130.486 322.333 130.605C322.579 130.784 322.85 130.559 322.992 130.351C325.504 126.575 327.591 122.51 329.216 118.232",
    fill: "#E4BAFF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M310.423 120.712C311.273 119.442 311.778 117.938 311.885 116.347C311.9 116.139 311.885 115.882 311.686 115.741C311.44 115.565 311.14 115.718 310.952 115.885C310.047 116.688 309.486 117.773 308.937 118.841C308.191 120.293 307.445 121.748 306.699 123.2C306.381 123.818 306.058 124.485 306.179 125.227C306.222 125.49 306.396 125.813 306.676 125.845C306.864 125.865 307.003 125.741 307.116 125.619C308.127 124.56 309.018 123.391 309.764 122.135",
    fill: "#E4BAFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M290.398 122.86C290.338 121.942 290.051 121.001 289.571 120.126C289.366 119.753 288.959 119.32 288.589 119.445C288.438 119.494 288.352 119.626 288.285 119.759C287.869 120.599 288.022 121.659 288.169 122.658C288.759 126.685 289.129 130.703 289.282 134.69C289.337 136.119 289.366 137.565 289.811 139C289.869 139.19 289.953 139.398 290.132 139.513C290.364 139.664 290.664 139.58 290.806 139.401C290.947 139.222 290.971 138.974 290.991 138.734C291.372 133.971 291.225 129.086 290.554 124.179",
    fill: "#E4BAFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M287.496 113.977C287.195 114.032 287.158 114.401 287.192 114.704C287.215 114.912 287.25 115.123 287.363 115.316C287.476 115.51 287.684 115.68 287.903 115.703C288.146 115.726 288.334 115.568 288.456 115.392C288.626 115.146 288.722 114.829 288.629 114.511C288.537 114.193 288.227 113.882 287.886 113.841",
    fill: "#E4BAFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M274.383 120.57C274.348 122.779 274.314 124.987 274.279 127.195C274.215 131.196 273.892 134.026 273.328 135.691C272.108 139.202 269.57 141.733 265.766 143.416C263.459 144.461 260.874 145.059 257.975 145.241C252.919 145.561 248.794 144.597 245.414 142.204C243.769 141.029 242.538 139.603 241.734 137.902C240.934 136.202 240.309 133.676 239.881 130.322C239.714 129.011 239.482 126.855 239.19 123.847C238.974 121.722 238.823 120.319 238.736 119.638C238.549 118.148 238.309 117.132 238.014 116.587C237.719 116.041 237.167 115.57 236.352 115.172C235.074 114.566 234.363 113.795 234.23 112.845C234.131 112.147 234.345 111.486 234.877 110.859C235.409 110.236 236.164 109.754 237.141 109.422C239.092 108.758 241.448 108.264 244.194 107.969C247.218 107.646 249.759 107.652 251.791 107.944C253.786 108.224 254.827 109.147 254.916 110.68C254.963 111.439 254.714 112.063 254.185 112.554C254.064 112.672 253.54 112.99 252.618 113.512C252.06 113.809 251.705 114.3 251.549 114.984C251.392 115.669 251.372 116.777 251.488 118.313C251.606 119.883 251.788 123.281 252.049 128.506C252.199 131.618 253.162 133.91 254.879 135.414C256.284 136.652 257.998 137.207 260.056 137.1C261.363 137.031 262.539 136.713 263.592 136.139C264.644 135.564 265.445 134.814 265.991 133.875C266.428 133.157 266.722 132.363 266.878 131.488C267.032 130.616 267.101 129.43 267.081 127.926C267.055 125.934 267.026 123.945 267 121.953C266.85 117.375 266.682 114.696 266.497 113.913C266.315 113.131 265.722 112.522 264.713 112.1C263.762 111.714 263.106 111.359 262.75 111.027C262.395 110.695 262.21 110.279 262.192 109.771C262.158 108.685 262.788 107.866 264.098 107.326C265.404 106.786 267.526 106.474 270.46 106.448C273.337 106.425 275.421 106.694 276.699 107.202C277.976 107.71 278.592 108.506 278.557 109.572C278.54 110.097 278.419 110.484 278.193 110.732C277.968 110.98 277.378 111.359 276.435 111.87C275.458 112.398 274.9 112.978 274.756 113.602C274.608 114.225 274.487 116.546 274.386 120.564L274.383 120.57Z",
    fill: "#328FFF",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M276.039 118.053C275.99 120.261 275.941 122.47 275.892 124.678C275.802 128.679 275.458 131.508 274.877 133.168C273.623 136.67 271.038 139.187 267.176 140.847C264.835 141.878 262.219 142.461 259.281 142.628C254.165 142.923 249.999 141.935 246.6 139.525C244.946 138.341 243.712 136.909 242.911 135.203C242.113 133.497 241.503 130.968 241.095 127.611C240.936 126.301 240.717 124.141 240.445 121.13C240.243 119.006 240.101 117.6 240.02 116.919C239.841 115.429 239.607 114.41 239.312 113.864C239.02 113.319 238.465 112.842 237.644 112.441C236.357 111.829 235.646 111.056 235.519 110.103C235.427 109.404 235.646 108.743 236.19 108.12C236.73 107.496 237.496 107.02 238.485 106.694C240.459 106.041 242.841 105.556 245.62 105.276C248.675 104.967 251.239 104.988 253.292 105.293C255.304 105.585 256.35 106.515 256.428 108.05C256.469 108.81 256.214 109.433 255.677 109.918C255.555 110.034 255.023 110.351 254.087 110.868C253.52 111.162 253.159 111.653 252.997 112.334C252.832 113.019 252.806 114.127 252.913 115.663C253.02 117.233 253.182 120.634 253.407 125.859C253.537 128.971 254.491 131.269 256.217 132.784C257.628 134.031 259.36 134.594 261.441 134.499C262.762 134.438 263.953 134.127 265.023 133.558C266.089 132.992 266.905 132.244 267.465 131.309C267.911 130.593 268.217 129.799 268.379 128.928C268.541 128.056 268.616 126.869 268.607 125.368C268.593 123.376 268.578 121.384 268.564 119.395C268.442 114.817 268.289 112.135 268.11 111.35C267.931 110.565 267.335 109.956 266.321 109.526C265.361 109.133 264.702 108.772 264.343 108.44C263.988 108.108 263.8 107.687 263.788 107.181C263.762 106.096 264.401 105.282 265.728 104.748C267.052 104.217 269.197 103.917 272.16 103.911C275.065 103.905 277.17 104.188 278.456 104.705C279.743 105.221 280.361 106.021 280.321 107.089C280.301 107.614 280.176 108.001 279.945 108.247C279.714 108.495 279.118 108.867 278.164 109.373C277.173 109.895 276.606 110.472 276.456 111.096C276.305 111.719 276.164 114.038 276.039 118.056V118.053Z",
    fill: "#78D2FF",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M200.835 66.3826C200.853 67.1707 200.859 67.9617 200.887 68.7498C201.133 75.4038 204.978 80.854 211.161 83.048C215.792 84.6906 220.559 84.858 225.274 83.4839C230.651 81.9164 234.239 78.4032 235.817 72.9847C236.788 69.6505 236.942 66.2469 236.343 62.829C235.395 57.4019 232.49 53.4239 227.376 51.2213C222.334 49.0475 217.119 48.8714 211.907 50.439C206.747 51.992 203.307 55.4533 201.758 60.6177C201.203 62.471 200.78 64.3648 200.835 66.3884V66.3826Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M202.394 63.6026C202.411 64.3907 202.417 65.1817 202.446 65.9697C202.691 72.6238 206.536 78.074 212.72 80.2679C217.351 81.9105 222.118 82.078 226.832 80.7038C232.209 79.1363 235.797 75.6231 237.375 70.2046C238.347 66.8704 238.5 63.4669 237.901 60.049C236.953 54.6218 234.048 50.6438 228.934 48.4412C223.892 46.2675 218.677 46.0914 213.465 47.6589C208.305 49.212 204.865 52.6733 203.316 57.8377C202.761 59.691 202.446 61.8301 202.394 63.6084V63.6026Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M216.489 77.3669C224.451 79.8755 231.909 73.8681 232.158 66.6685C223.757 69.3445 210.401 69.2723 210.401 69.2723C210.401 69.2723 210.676 75.5337 216.487 77.3669H216.489Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M238.237 64.6418C238.277 63.1176 238.17 61.5847 237.901 60.046C236.953 54.6189 234.048 50.6409 228.934 48.4383C223.892 46.2646 218.677 46.0885 213.465 47.656C208.305 49.2091 204.865 52.6703 203.316 57.8348C202.758 59.6881 202.446 61.8272 202.394 63.6054C202.411 64.3935 202.417 65.1845 202.446 65.9726C202.48 66.9541 202.605 67.9067 202.792 68.8276C219.157 70.45 231.487 67.364 238.234 64.6418H238.237Z",
    fill: "#FCE3B9",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M215.078 66.5152C215.078 66.5152 210.011 66.3709 208.005 64.8178C206.227 63.4408 206.464 53.646 211.3 48.47C207.334 50.2684 204.637 53.4295 203.316 57.8318C202.758 59.6851 202.446 61.8242 202.394 63.6025C202.411 64.3905 202.417 65.1815 202.446 65.9696C202.48 66.9511 202.605 67.9038 202.792 68.8246C207.077 69.249 211.078 69.35 214.781 69.2201C214.677 69.2086 214.567 69.1941 214.437 69.1826C208.56 68.5821 215.076 66.5152 215.076 66.5152H215.078Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M225.095 69.512C225.037 72.3814 225.983 74.5523 227.969 73.3745C229.955 72.1967 229.966 68.4929 229.966 68.4929L225.095 69.512Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M183.002 18.2773C184.875 23.947 190.261 49.1687 190.261 49.1687C201.972 36.4178 216.787 20.734 216.787 20.734L201.364 48.4673L210.875 47.6445L193.759 65.4473L216.466 101.411L196.219 81.3188L197.034 94.3814L185.962 78.7409C185.962 78.7409 176.266 102.049 169.178 112.926C171.612 101.705 175.986 82.2772 175.986 82.2772C175.986 82.2772 171.072 84.3037 169.939 85.2044C172.321 79.1335 177.619 59.717 177.619 59.717L172.546 60.8688C176.116 51.8967 180.12 37.1107 180.12 37.1107L175.752 40.0177C175.752 40.0177 180.95 23.0059 183.002 18.2773Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M186.801 15.532C189.012 23.0058 194.06 46.4234 194.06 46.4234C205.77 33.6725 220.583 17.9886 220.583 17.9886L205.16 45.7219L214.671 44.8992L197.555 62.7019L220.262 98.6654L200.015 78.5734L200.83 91.6361L189.758 75.9955C189.758 75.9955 180.062 99.3034 172.974 110.178C176.088 98.954 179.782 79.5289 179.782 79.5289C179.782 79.5289 174.868 81.5555 173.734 82.4561C176.116 76.3852 181.415 56.9688 181.415 56.9688L176.342 58.1206C179.912 49.1485 183.916 34.3624 183.916 34.3624L179.548 37.2694C179.548 37.2694 184.303 21.5105 186.801 15.532Z",
    fill: "url(#paint2_linear_984_1916)",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M351.328 36.4957C349.417 37.6561 348.269 42.8206 350.955 46.0682C352.386 47.7974 357.008 57.9531 357.505 60.147C358.546 64.7485 355.08 69.0845 354.325 73.7437C353.759 77.2367 354.831 80.9693 357.153 83.5934C358.491 85.1032 360.304 86.2781 362.293 86.4051C364.281 86.5293 366.403 85.4092 367.091 83.4953C367.513 82.3175 367.369 81.0069 367.088 79.7857C366.36 76.6161 364.753 73.6744 364.351 70.4441C364.224 69.428 364.25 68.3022 364.877 67.5025C365.556 66.6336 366.808 66.3911 367.854 66.7C368.901 67.006 369.762 67.7681 370.474 68.611C373.888 72.6727 373.064 79.6501 377.056 83.12C382.233 87.6205 385.613 80.4959 386.63 77.7881C388.226 73.5388 387.781 68.0799 386.121 65.7271C384.367 63.2445 381.337 62.0032 378.363 61.625C375.388 61.2469 372.379 61.6077 369.384 61.6655C368.123 61.6914 366.689 61.5789 365.903 60.5743C365.082 59.5235 365.377 57.9126 366.175 56.8417C366.973 55.7707 368.155 55.0923 369.248 54.3417C372.899 51.8389 375.83 48.2535 377.594 44.137C378.654 41.663 379.299 38.8686 378.637 36.2561C377.975 33.6406 375.72 31.3254 373.078 31.3254C370.459 31.3254 368.25 33.5367 367.285 36.028C366.319 38.5193 366.311 41.2675 366.175 43.9435C366.039 46.6196 365.718 49.4111 364.253 51.631C363.689 52.4826 362.755 53.2938 361.784 53.034C361.301 52.9041 360.919 52.5317 360.587 52.1506C359.35 50.7361 358.928 31.8855 351.339 36.4957H351.328Z",
    fill: "#EC008C",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M373.743 32.0585C373.24 32.0036 373.015 32.4135 373.072 32.6733C373.13 32.9331 373.483 33.6808 374.492 33.4181C375.501 33.1583 374.92 32.1884 373.746 32.0585H373.743Z",
    fill: "#FF71CF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M376.674 34.5353C376.137 34.0878 375.405 34.4429 375.853 35.5225C376.301 36.6022 377.094 39.7892 375.717 43.5362C374.341 47.2833 373.671 48.1753 373.064 49.0529C372.457 49.9304 373.116 49.5176 374.035 48.4553C374.957 47.393 377.325 43.4785 377.625 39.8094C377.923 36.1374 377.01 34.8153 376.674 34.5353Z",
    fill: "#FF71CF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M353.701 36.3829C353.03 36.2905 351.929 36.7178 352.114 36.7755C352.299 36.8332 354.016 36.1606 355.285 38.3026C356.554 40.4446 358.002 46.0796 358.456 48.4958C358.737 49.9854 358.644 48.5131 358.607 47.6384C358.569 46.7638 358 41.6109 356.031 38.1727C354.984 36.3454 353.698 36.3829 353.698 36.3829H353.701Z",
    fill: "#FF71CF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M370.681 62.6498C369.658 62.7479 370.719 63.0424 371.933 63.077C373.147 63.1116 379.623 64.148 381.617 65.8829C383.557 67.5659 385.852 69.4366 385.852 75.2188C385.852 76.2638 386.413 75.3487 386.561 73.5242C386.708 71.6998 386.841 66.6479 382.12 64.0931C377.4 61.5412 371.017 62.618 370.681 62.6498Z",
    fill: "#FF71CF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M362.798 68.5184C362.483 69.6788 362.379 72.1239 363.871 75.8883C365.363 79.6526 366.331 80.6572 366.036 82.5221C365.923 83.2294 366.371 82.8454 366.409 81.8264C366.447 80.8074 365.851 78.5845 364.623 75.1579C363.394 71.7313 363.059 67.8717 364.784 66.7949C365.92 66.0877 364.55 66.3764 364.01 66.7574C363.469 67.1385 363.001 67.7649 362.796 68.5184H362.798Z",
    fill: "#FF71CF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M310.308 65.6927L309.001 78.0106C308.972 78.2762 309.166 78.5158 309.432 78.5447L313.594 78.9835C313.86 79.0123 314.054 79.249 314.025 79.5175L313.042 88.7927C313.013 89.0583 313.207 89.2979 313.473 89.3268L317.919 89.7973C318.046 89.8118 318.176 89.7742 318.275 89.6934L323.614 85.3834C323.724 85.294 323.79 85.1612 323.793 85.0168L324.467 54.7923C324.473 54.5036 324.227 54.2726 323.938 54.2986L311.785 55.4187C311.553 55.4389 311.371 55.6208 311.345 55.8488L310.302 65.6927H310.308Z",
    fill: "#EF4136",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M318.043 43.3262L312.375 47.9046L314.667 50.7336L319.792 51.2764L318.043 43.3262Z",
    fill: "#EF4136",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M312.215 48.0286L306.859 52.3559C306.757 52.4367 306.694 52.5551 306.682 52.6821L306.483 54.5614C306.454 54.8269 306.648 55.0665 306.914 55.0954L313.64 55.8056C313.906 55.8344 314.146 55.641 314.175 55.3754L314.886 48.6579C314.915 48.3923 314.722 48.1527 314.456 48.1238L312.574 47.9247C312.447 47.9102 312.316 47.9478 312.218 48.0286H312.215Z",
    fill: "#EF4136",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M309.741 68.4928L304.523 72.7075C304.422 72.7883 304.295 72.8258 304.167 72.8114L292.032 71.5297C291.766 71.5008 291.572 71.2641 291.601 70.9956L293.399 54.0387C293.428 53.7731 293.665 53.5797 293.934 53.6086L303.433 54.6132C303.604 54.6305 303.751 54.7373 303.823 54.8903L309.882 67.9125C309.975 68.1146 309.92 68.3542 309.747 68.4928H309.741Z",
    fill: "#EF4136",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M293.411 76.9943L288.054 81.3216C287.953 81.4024 287.826 81.44 287.698 81.4255L285.816 81.2263C285.55 81.1975 285.357 80.9608 285.386 80.6923L285.84 76.4025C285.863 76.1947 286.013 76.0244 286.218 75.9811L293.182 74.454C293.506 74.3818 293.804 74.6503 293.769 74.9794L293.59 76.671C293.575 76.798 293.512 76.9164 293.413 76.9972L293.411 76.9943Z",
    fill: "#EF4136",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M282.064 39.6164L276.47 43.8542C276.369 43.935 276.306 44.0534 276.294 44.1804L272.027 84.4596C271.998 84.7252 272.192 84.9648 272.458 84.9936L282.029 86.004C282.157 86.0185 282.287 85.9809 282.385 85.9001L287.684 81.619C287.817 81.5122 287.883 81.3448 287.86 81.1744L282.57 40.3179C282.518 39.9455 282.356 39.3797 282.064 39.6164Z",
    fill: "#EF4136",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M317.82 43.7041L317.387 47.8062C317.358 48.0862 317.103 48.2912 316.823 48.2623L312.715 47.8293C312.435 47.8004 312.18 48.0025 312.151 48.2854L311.718 52.3875C311.689 52.6675 311.435 52.8725 311.154 52.8436L309.099 52.6271L306.535 52.3557L301.915 51.8679C301.635 51.839 301.429 51.585 301.458 51.305L301.892 47.2028C301.921 46.9228 301.719 46.6688 301.435 46.6399L297.327 46.2069C297.047 46.178 296.842 45.924 296.871 45.644L297.304 41.5419C297.333 41.2619 297.131 41.0078 296.848 40.979L292.228 40.4911L287.1 39.9484L282.48 39.4605C282.2 39.4316 281.945 39.6337 281.917 39.9166L277.684 79.861C277.655 80.141 277.858 80.395 278.141 80.4239L282.761 80.9117L287.38 81.3996C287.661 81.4285 287.915 81.2264 287.944 80.9435L288.377 76.8414C288.406 76.5614 288.661 76.3564 288.941 76.3853L293.049 76.8183C293.329 76.8472 293.584 76.6451 293.613 76.3622L295.674 56.8995C295.703 56.6195 295.957 56.4145 296.238 56.4434L300.345 56.8764C300.626 56.9053 300.831 57.1593 300.802 57.4394L299.825 66.6626C299.796 66.9426 299.999 67.1967 300.282 67.2255L304.901 67.7134L309.521 68.2013C309.801 68.2301 310.056 68.0281 310.085 67.7451L311.062 58.5219C311.091 58.2419 311.345 58.0369 311.625 58.0658L315.733 58.4988C316.014 58.5277 316.219 58.7817 316.19 59.0617L314.669 73.4061C314.64 73.6861 314.843 73.9402 315.126 73.969L319.234 74.4021C319.514 74.4309 319.72 74.685 319.691 74.965L318.714 84.1882C318.685 84.4682 318.887 84.7223 319.17 84.7512L323.278 85.1842C323.559 85.213 323.813 85.011 323.842 84.7281L327.314 51.9545L328.074 44.7837C328.103 44.5037 327.901 44.2497 327.617 44.2208L318.381 43.2451C318.101 43.2162 317.846 43.4183 317.817 43.7012L317.82 43.7041Z",
    fill: "#FFFB53",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M254.72 39.7086C251.852 39.8298 248.984 39.4719 246.117 39.5209C243.246 39.57 240.277 40.0665 237.924 41.7091C236.271 42.8638 235.019 44.518 234.056 46.2875C232.989 48.2506 232.235 50.433 232.241 52.6644C232.247 54.8988 233.085 57.1851 234.776 58.6487C236.609 60.2336 239.364 60.6666 241.593 59.7168C243.824 58.7671 245.42 56.4836 245.541 54.0645C248.846 52.1564 252.297 50.202 256.104 49.9133C256.642 49.8729 257.206 49.87 257.691 50.1039C258.744 50.6119 259.013 52.0698 258.579 53.1552C258.145 54.2377 257.214 55.0287 256.321 55.7822C248.074 62.7306 240.141 70.4095 235.163 79.9733C234.108 82.0028 233.174 84.1736 233.122 86.4599C233.07 88.7463 234.065 91.1798 236.074 92.2797C238.982 93.8732 242.518 92.2104 245.489 90.7381C248.493 89.2486 251.586 87.9351 254.743 86.8092C255.859 86.4109 257.021 86.0327 258.203 86.0991C260.123 86.2059 261.759 87.4472 263.508 88.2411C268.003 90.2791 273.825 89.0811 276.959 85.2735C280.092 81.4629 280.052 75.3343 276.687 71.7258C274.684 69.5781 271.715 68.4031 268.778 68.4638C265.841 68.5244 262.967 69.7859 260.839 71.8124C260.478 72.1559 260.123 72.5312 259.657 72.7102C259.278 72.8574 258.865 72.8603 258.466 72.9325C256.399 73.3049 255.145 75.3487 253.511 76.6651C252.497 77.4821 251.274 78.0392 249.99 78.273C249.626 78.3394 249.247 78.3798 248.889 78.2904C248.039 78.0796 247.507 77.1645 247.484 76.2898C247.461 75.4151 247.842 74.5808 248.279 73.8245C249.649 71.4631 251.635 69.5232 253.67 67.7017C257.712 64.0788 262.033 60.7849 266.367 57.5171C268.783 55.6927 271.232 53.8509 273.125 51.4866C275.016 49.1252 276.323 46.1432 276.065 43.1294C275.675 38.5048 271.801 35.8576 267.355 36.4003C265.624 36.6111 264.233 37.4973 262.626 38.1064C260.105 39.0619 257.408 39.5989 254.717 39.7144L254.72 39.7086Z",
    fill: "url(#paint3_linear_984_1916)",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M244.09 46.2068C245.359 48.7241 245.839 51.631 245.451 54.4226",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M245.619 53.8826C247.316 52.2574 248.056 49.6968 247.487 47.4163",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M260.949 71.7373C259.761 72.8429 258.614 74.0207 257.772 75.4093C256.931 76.7978 256.408 78.4231 256.561 80.0397",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M255.141 75.2043C254.847 75.3573 254.644 75.6345 254.456 75.9058C253.609 77.1529 252.93 78.5184 252.447 79.9473",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M249.158 72.2947C246.793 74.8668 245.457 78.3569 245.504 81.847",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M257.264 49.9595C258.536 49.9855 259.718 50.8486 260.247 52.0033C260.776 53.158 260.681 54.5466 260.123 55.6897",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M339.394 87.7043C344.514 87.3521 349.634 86.9884 354.756 86.6622C355.528 86.6131 355.878 86.437 355.794 85.5623C355.592 83.4347 355.453 81.3014 355.349 79.1652C355.311 78.3742 354.993 78.175 354.247 78.2357C351.634 78.4435 349.015 78.5821 346.402 78.7986C345.647 78.8621 345.326 78.6369 345.277 77.8777C344.98 73.357 344.667 68.8363 344.338 64.3156C344.277 63.5073 344.569 63.2302 345.381 63.1898C348 63.057 350.611 62.8318 353.23 62.6759C353.929 62.6355 354.201 62.3901 354.14 61.6569C353.955 59.4918 353.802 57.321 353.695 55.1501C353.658 54.3534 353.325 54.1859 352.591 54.2379C344.821 54.7922 330.549 55.8718 322.778 56.4463C322.319 56.4809 321.729 56.836 321.471 57.2228C321.281 59.8209 321.376 64.9507 322.434 64.7602C322.746 64.8093 323.747 64.6794 324.053 64.6592C326.045 64.5408 328.037 64.4282 330.02 64.2435C330.867 64.1655 331.202 64.3965 331.257 65.2769C331.529 69.7254 331.829 74.1711 332.179 78.6109C332.254 79.552 331.89 79.7714 331.043 79.9042C329.485 80.1467 325.513 80.1438 324.007 80.597C322.402 81.082 322.998 81.9683 322.7 83.6397C322.501 84.7598 323.183 86.4918 323.047 87.6206C322.911 88.7464 322.995 88.8244 324.143 88.7464C329.228 88.4029 334.31 88.0507 339.394 87.7014V87.7043Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M340.646 84.8465C345.766 84.4944 350.886 84.1306 356.008 83.8044C356.997 83.7409 357.294 83.4696 356.875 81.7923C356.514 80.3489 356.381 78.8536 356.546 77.3756C356.737 75.6839 356.508 75.2942 355.502 75.375C352.889 75.5829 350.27 75.7214 347.657 75.938C346.723 76.0159 346.454 75.6522 346.541 74.382C346.818 70.2279 346.405 66.0681 345.662 61.9717C345.442 60.7564 345.668 60.3782 346.636 60.3263C349.255 60.1935 351.866 59.9683 354.485 59.8124C355.41 59.7576 355.586 59.3476 355.233 57.9274C354.858 56.4176 354.719 54.8587 354.895 53.3143C355.086 51.6255 354.826 51.3051 353.843 51.3744C346.072 51.9286 331.8 53.0083 324.03 53.5828C323.715 53.6058 322.654 53.6722 322.7 54.7288C322.784 56.611 322.908 59.4429 323.007 60.8892C323.05 61.5358 323.354 61.9169 323.686 61.8967C323.686 61.8967 324.998 61.8158 325.305 61.7956C327.297 61.6773 329.288 61.5647 331.271 61.3799C332.355 61.2789 332.601 61.6888 332.491 63.3198C332.228 67.1593 332.419 71.0218 333.266 74.7746C333.668 76.5586 333.376 76.8704 332.295 77.0407C330.737 77.2832 327.242 77.5978 325.259 77.7335C323.894 77.8259 324.027 78.6198 324.07 79.2606C324.163 80.5857 324.143 82.4505 324.221 83.6052C324.279 84.4424 324.383 85.9551 326.201 85.8309C331.286 85.4874 335.561 85.1901 340.646 84.8408V84.8465Z",
    fill: "url(#paint4_linear_984_1916)",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M322.052 107.458L324.995 103.867L325.651 110.397L322.708 113.991L322.052 107.458Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M322.708 113.991L325.651 110.397L326.305 116.93L323.365 120.521L322.708 113.991Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M332.847 116.274L329.904 119.866L323.365 120.521L326.305 116.93L332.847 116.274Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M359.005 113.656L356.065 117.25L349.523 117.903L352.466 114.312L359.005 113.656Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M353.122 120.841L350.18 124.435L343.638 125.088L346.581 121.497L353.122 120.841Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M347.237 128.027L344.294 131.621L337.755 132.273L340.698 128.682L347.237 128.027Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M338.732 109.089L335.789 112.681L329.248 113.336L332.19 109.742L338.732 109.089Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M345.271 108.434L342.329 112.028L335.79 112.681L338.732 109.089L345.271 108.434Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M351.81 107.779L348.867 111.373L342.328 112.028L345.271 108.434L351.81 107.779Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M342.008 141.745L339.065 145.336L332.526 145.991L335.469 142.397L342.008 141.745Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M348.546 141.089L345.606 144.681L339.064 145.336L342.007 141.745L348.546 141.089Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M355.088 140.434L352.145 144.028L345.606 144.68L348.546 141.089L355.088 140.434Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M361.627 139.779L358.685 143.373L352.146 144.028L355.088 140.434L361.627 139.779Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M368.169 139.126L365.226 142.717L358.685 143.373L361.627 139.779L368.169 139.126Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M349.523 117.903L352.466 114.312L351.81 107.779L348.867 111.373L349.523 117.903Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M343.638 125.088L346.581 121.497L345.927 114.964L342.984 118.558L343.638 125.088Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M337.755 132.273L340.698 128.682L340.042 122.149L337.099 125.743L337.755 132.273Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M331.87 139.458L334.812 135.867L334.156 129.337L331.213 132.928L331.87 139.458Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M332.526 145.991L335.469 142.397L334.812 135.867L331.87 139.458L332.526 145.991Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M358.031 136.843L360.971 133.249L360.318 126.719L357.375 130.31L358.031 136.843Z",
    fill: "#71FFB8",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M332.187 109.751L325.646 110.405L326.301 116.937L332.842 116.282L332.187 109.751Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M331.533 103.22L324.992 103.874L325.647 110.406L332.188 109.752L331.533 103.22Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M338.072 102.564L331.531 103.218L332.186 109.75L338.727 109.096L338.072 102.564Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M344.611 101.91L338.07 102.565L338.725 109.097L345.266 108.442L344.611 101.91Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M351.154 101.257L344.613 101.911L345.268 108.443L351.809 107.789L351.154 101.257Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M357.693 100.604L351.152 101.258L351.807 107.79L358.348 107.135L357.693 100.604Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M358.347 107.134L351.806 107.788L352.461 114.32L359.002 113.666L358.347 107.134Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M366.853 126.074L360.312 126.729L360.967 133.26L367.508 132.606L366.853 126.074Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M352.462 114.317L345.921 114.972L346.577 121.504L353.118 120.849L352.462 114.317Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M346.58 121.504L340.039 122.158L340.694 128.69L347.235 128.036L346.58 121.504Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M340.692 128.691L334.151 129.345L334.807 135.877L341.348 135.223L340.692 128.691Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M341.35 135.221L334.809 135.875L335.464 142.407L342.005 141.753L341.35 135.221Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M347.889 134.565L341.348 135.219L342.003 141.751L348.544 141.097L347.889 134.565Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M354.428 133.914L347.887 134.569L348.542 141.1L355.083 140.446L354.428 133.914Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M360.971 133.258L354.43 133.912L355.085 140.444L361.626 139.789L360.971 133.258Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M367.51 132.604L360.969 133.259L361.624 139.79L368.165 139.136L367.51 132.604Z",
    fill: "#FEFF0D",
    stroke: "black",
    strokeWidth: 0.36125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_1916",
    x1: 85.1575,
    y1: 21.8983,
    x2: 129.267,
    y2: 69.2483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FF58D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF231D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EDFF36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_1916",
    x1: 186.946,
    y1: 103.146,
    x2: 237.661,
    y2: 138.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#32F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#63F8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A5F99C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D6FA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3FA5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFFB51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#FFE951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFBA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FF6F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF1958"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_984_1916",
    x1: 199.048,
    y1: 15.8679,
    x2: 196.449,
    y2: 110.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6BDCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#8CDFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BAE48A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DCE859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F1EB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F9DF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FABD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FD88BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FF58FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_984_1916",
    x1: 236.042,
    y1: 89.7388,
    x2: 267.504,
    y2: 29.6822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "#6BDCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#38FF34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_984_1916",
    x1: 338.501,
    y1: 52.4493,
    x2: 340.725,
    y2: 84.8726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6BDCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#8CDFCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#BAE48A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DCE859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F1EB3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#F9DF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FABD71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FD88BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF58FE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKozmikBumzLogo);
export default __webpack_public_path__ + "static/media/kozmikBumzLogo.5e0b95dc6843d06c28b9c9591b45a955.svg";
export { ForwardRef as ReactComponent };